import React, { ReactNode } from 'react';
interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}
export function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-surface px-6 py-20 text-center" data-id="element-63" data-mp="3gvyce9qalh7v">
      <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-background text-muted-foreground shadow-soft" data-id="element-64" data-mp="3l0fsnyxg1cdw">
        {icon}
      </span>
      <h3 className="text-lg font-semibold text-navy" data-id="element-65" data-mp="3byokmnffktgv">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground" data-id="element-66" data-mp="2x9io577z9hco">
        {description}
      </p>
      {action && <div className="mt-7" data-id="element-67" data-mp="328vbdt2rgqfs">{action}</div>}
    </div>;
}